import { clearTokens } from './authTokens';
import { clearUserSession } from './authSession';
import { clearRegularExamStartRecords } from './regularExamStartRecord';

/**
 * Login path including optional REACT_APP_BASE_PATH (must match BrowserRouter basename).
 */
export function getLoginPathname(query?: URLSearchParams): string {
  const raw = process.env.REACT_APP_BASE_PATH ?? '/';
  const base = raw === '/' ? '' : raw.replace(/\/$/, '');
  const q = query && query.toString() ? `?${query.toString()}` : '';
  return `${base}/login${q}`;
}

/**
 * Clears auth and sends the user to login (full navigation so React state resets).
 */
export function clearAuthAndRedirectToLogin(reason: string = 'session_invalid'): void {
  clearTokens();
  clearUserSession();
  clearRegularExamStartRecords();
  if (typeof window === 'undefined') return;
  const params = reason ? new URLSearchParams({ reason }) : undefined;
  window.location.replace(getLoginPathname(params));
}
